import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LocksmithLanding, {
  AreaSeoPage,
  GuidePage,
  ImprintPage,
  NotFoundPage,
  PrivacyPage,
  ServicesOverviewPage,
  ServiceSeoPage,
} from "@/pages/LocksmithLanding";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LocksmithLanding />} />
          <Route path="/leistungen" element={<ServicesOverviewPage />} />
          <Route path="/impressum" element={<ImprintPage />} />
          <Route path="/datenschutz" element={<PrivacyPage />} />
          <Route path="/tueroeffnung-dueren" element={<ServiceSeoPage slug="tueroeffnung-dueren" />} />
          <Route path="/schlosswechsel-dueren" element={<ServiceSeoPage slug="schlosswechsel-dueren" />} />
          <Route path="/autooeffnung-dueren" element={<ServiceSeoPage slug="autooeffnung-dueren" />} />
          <Route path="/autoschluessel-dueren" element={<ServiceSeoPage slug="autoschluessel-dueren" />} />
          <Route path="/schluesselnotdienst-dueren" element={<ServiceSeoPage slug="schluesselnotdienst-dueren" />} />
          <Route path="/schluesseldienst-birkesdorf" element={<AreaSeoPage slug="schluesseldienst-birkesdorf" />} />
          <Route path="/schluesseldienst-mariaweiler" element={<AreaSeoPage slug="schluesseldienst-mariaweiler" />} />
          <Route path="/schluesseldienst-lendersdorf" element={<AreaSeoPage slug="schluesseldienst-lendersdorf" />} />
          <Route path="/schluesseldienst-niederau" element={<AreaSeoPage slug="schluesseldienst-niederau" />} />
          <Route path="/schluesseldienst-kreuzau" element={<AreaSeoPage slug="schluesseldienst-kreuzau" />} />
          <Route path="/schluesseldienst-merzenich" element={<AreaSeoPage slug="schluesseldienst-merzenich" />} />
          <Route path="/schluesseldienst-dueren-zentrum" element={<AreaSeoPage slug="schluesseldienst-dueren-zentrum" />} />
          <Route path="/schluesseldienst-juelich" element={<AreaSeoPage slug="schluesseldienst-juelich" />} />
          <Route path="/schluesseldienst-kerpen" element={<AreaSeoPage slug="schluesseldienst-kerpen" />} />
          <Route path="/schluesseldienst-eschweiler" element={<AreaSeoPage slug="schluesseldienst-eschweiler" />} />
          <Route path="/schluesseldienst-huertgenwald" element={<AreaSeoPage slug="schluesseldienst-huertgenwald" />} />
          <Route path="/ratgeber/tueroeffnung-kosten-dueren" element={<GuidePage slug="tueroeffnung-kosten-dueren" />} />
          <Route path="/ratgeber/tuer-zugefallen-was-tun" element={<GuidePage slug="tuer-zugefallen-was-tun" />} />
          <Route path="/ratgeber/schluessel-verloren-schloss-wechseln" element={<GuidePage slug="schluessel-verloren-schloss-wechseln" />} />
          <Route path="/ratgeber/unserioese-schluesseldienste-erkennen" element={<GuidePage slug="unserioese-schluesseldienste-erkennen" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
